import { Pencil, Trash2, Plus, Layers } from "lucide-react";

// başlık kapsamı rozeti: projeye özel / tüm projelerde
function ScopeBadge({ c }) {
  if (c.scope !== "projects") return <span className="px-1.5 py-0.5 rounded bg-sky-100 text-sky-700 text-[10px] font-semibold" data-testid={`cat-scope-${c.id}`}>Tüm projelerde</span>;
  const n = (c.project_ids || []).length;
  return <span className="px-1.5 py-0.5 rounded bg-amber-200 text-amber-800 text-[10px] font-semibold" data-testid={`cat-scope-${c.id}`}>{n > 0 ? `${n} projeye özel` : "Hiçbir projede yok"}</span>;
}

// hizmet başlığı grubu: başlık satırı (rozetler + Hizmet Ekle / Düzenle / Sil) ve altında tablo
export default function CategoryGroup({ c, count, kalemCount = 0, isAdmin, onAddSvc, onEdit, onDelete, children }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md overflow-hidden" data-testid={`cat-group-${c.id}`}>
      <div className="flex items-center gap-2 px-3 py-2 bg-slate-100 border-b border-slate-200 flex-wrap">
        <Layers className="w-3.5 h-3.5 text-slate-500" />
        <span className="text-xs font-bold text-slate-800">{c.name}</span>
        <span className="px-1.5 py-0.5 rounded bg-slate-200 text-slate-600 text-[10px] font-semibold" data-testid={`cat-count-${c.id}`}>{count} hizmet{kalemCount > 0 && ` · ${kalemCount} kalem`}</span>
        {c.status !== "Aktif" && <span className="text-[10px] text-red-600 font-semibold">{c.status}</span>}
        <ScopeBadge c={c} />
        <div className="ml-auto flex items-center gap-1">
          <button onClick={() => onAddSvc(c)} data-testid={`cat-add-svc-${c.id}`}
            className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-slate-300 bg-white text-[11px] font-semibold text-slate-700 hover:bg-slate-50">
            <Plus className="w-3 h-3" /> Hizmet Ekle
          </button>
          <button onClick={() => onEdit(c)} className="text-slate-600 hover:text-slate-900 px-1" data-testid={`cat-edit-${c.id}`}><Pencil className="w-3.5 h-3.5" /></button>
          {isAdmin && (
            <button onClick={() => onDelete(c)} className="text-red-700 hover:text-red-900 px-1" data-testid={`cat-delete-${c.id}`} title="Başlığı ve altındaki hizmetleri sil"><Trash2 className="w-3.5 h-3.5" /></button>
          )}
        </div>
      </div>
      {count === 0 ? (
        <div className="text-[11px] text-slate-400 px-3 py-2.5">Bu başlık altında hizmet yok — "Hizmet Ekle" ile bu başlığa hizmet açabilirsiniz.</div>
      ) : children}
    </div>
  );
}

export function OrphanGroup({ count, children }) {
  return (
    <div className="bg-amber-50/50 border border-amber-200 rounded-md overflow-hidden" data-testid="cat-group-none">
      <div className="flex items-center gap-2 px-3 py-2 bg-amber-100/60 border-b border-amber-200 flex-wrap">
        <Layers className="w-3.5 h-3.5 text-amber-600" />
        <span className="text-xs font-bold text-amber-800">Başlıksız Hizmetler</span>
        <span className="px-1.5 py-0.5 rounded bg-amber-200 text-amber-800 text-[10px] font-semibold">{count} hizmet</span>
        <span className="text-[10px] text-amber-700">Düzenle ile bir başlığa bağlayın</span>
      </div>
      {children}
    </div>
  );
}
